import * as React from "react";
import DashboardLayout from "../../../Layout/DashboardLayout";
import Table from "@mui/material/Table";
import { useSelector } from "react-redux";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router-dom";
import Stack from "@mui/material/Stack";
import { GetEmployees } from "../../../services/employee.handlers";
import { GetStores } from "../../../services/store.handlers";
import { jsonCheck } from "../../../constants";
import { MenuItem, Select } from "@mui/material";
import { GetOrganizations } from "../../../services/organization.handlers";

const TableRowData = [
  "ID",
  "Organization",
  "Store Name",
  "Contact Info",
  "Address",
  "Attached System's",
  "Status",
  "Action",
  "Attach / Remove System",
  // "Remove System",
];

const Stores = () => {
  const navigate = useNavigate();
  const [allData, setAllData] = React.useState([]);
  const [data, setData] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(20);
  const [organizations, setOrganization] = React.useState([]);
  const authToken = useSelector((state) => state.user.authToken);
  React.useEffect(() => {
    fetchOrganisations();
    fetchData();
  }, []);
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onChangeOrganisation = (value) => {
    if (value === "All") {
      setAllData(data);
    } else if (value !== "All") {
      const filterData = data.filter(
        (item, index) => item.organizationName === value
      );
      setAllData(filterData);
      return;
    }
  };
  const fetchData = () => {
    var options = {
      Authorization: "Bearer " + authToken,
    };
    GetStores(options).then((response) => {
      if (response.status) {
        setAllData(response.data);
        setData(response.data);
      }
    });
  };

  const fetchOrganisations = () => {
    var options = {
      Authorization: "Bearer " + authToken,
    };
    GetOrganizations(options).then((response) => {
      if (response.status) {
        setOrganization(response.data);
      }
    });
  };

  // console.log(data.length > 0 && typeof data[4].country);
  return (
    <DashboardLayout>
      <Stack direction="row" justifyContent={"space-between"}>
        <div>
          <h3 style={{ marginBottom: -5, marginTop: 0 }}>Store</h3>
        </div>
        <div
          className={"form-group"}
          style={{ margin: "0", marginRight: 10, width: "25%" }}
        >
          <Select
            fullWidth
            className={"form-input"}
            id="select-active"
            defaultValue={"All"}
            onChange={(e) => {
              onChangeOrganisation(e.target.value);
            }}
          >
            <MenuItem value="All">All Organization</MenuItem>
            {[...new Set(data.map((item) => item.organizationName))].map(
              (item, index) => (
                <MenuItem key={index} value={item}>
                  {item}
                </MenuItem>
              )
            )}
          </Select>
        </div>
      </Stack>
      <hr></hr>
      {/* <Stack
        spacing={2}
        direction="row"
        style={{ marginBottom: "30px", justifyContent: "end" }}
      >
        <Button onClick={() => navigate("/add_stores")} variant="contained">
          <AddIcon /> Add New Store
        </Button>
      </Stack> */}
      <TableContainer>
        <Table
          sx={{ minWidth: 750 }}
          aria-labelledby="tableTitle"
          size={"medium"}
        >
          <TableHead>
            <TableRow>
              {TableRowData.map((item, index) => (
                <TableCell key={index}>
                  {index == -1 ? (
                    <FormControlLabel
                      control={
                        <Checkbox
                          color="primary"
                          //   indeterminate={numSelected > 0 && numSelected < rowCount}
                          //   checked={rowCount > 0 && numSelected === rowCount}
                          //   onChange={onSelectAllClick}
                          inputProps={{
                            "aria-label": "select all ID",
                          }}
                        />
                      }
                      label={item}
                    />
                  ) : (
                    item
                  )}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {allData.length > 0 ? (
              allData
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((item, index) => (
                  <TableRow
                    hover
                    key={index}
                    //   selected={isItemSelected}
                  >
                    <TableCell>{item.store_Id}</TableCell>
                    <TableCell>{item.organizationName}</TableCell>
                    <TableCell>{item.store_Name}</TableCell>
                    <TableCell>
                      {item.store_Email}
                      <br />
                      {item.store_Number}
                    </TableCell>
                    <TableCell>
                      {item.store_Address_1 + " " + item.store_Address_2 + ", "}
                      {jsonCheck(item.city)
                        ? JSON.parse(item.city).label
                        : item.city}
                      {", "}
                      {jsonCheck(item.state)
                        ? JSON.parse(item.state).label
                        : item.state}
                      {", "}
                      {item.zip + " - "}
                      {jsonCheck(item.country)
                        ? JSON.parse(item.country).label
                        : item.country}
                    </TableCell>
                    <TableCell>
                      {item.systemIds.map((element) => element + ",")}
                    </TableCell>
                    <TableCell>
                      {item.isActive ? (
                        <span className={"label color-green"}>Active</span>
                      ) : (
                        <span className={"label color-red"}>Blocked</span>
                      )}
                    </TableCell>
                    <TableCell>
                      <Button
                        onClick={() => navigate("/updateStores/" + item.id)}
                        variant="contained"
                        color="primary"
                      >
                        Edit
                      </Button>
                    </TableCell>
                    <TableCell style={{ minWidth: "140px" }}>
                      <button
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate("/attachSystemToStore/" + item.id)
                        }
                      >
                        Attach
                      </button>
                      {" / "}
                      <button
                        style={{ cursor: "pointer" }}
                        onClick={() =>
                          navigate("/removeSystemToStore/" + item.id)
                        }
                      >
                        Remove
                      </button>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow hover tabIndex={-1}>
                <TableCell
                  colSpan={9}
                  align={"center"}
                  // padding="checkbox"
                >
                  No Records Available
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[20, 30, 40]}
        component="div"
        count={allData.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </DashboardLayout>
  );
};

export default Stores;
